import { render } from "./BandView.vue?vue&type=template&id=493c9622&scoped=true"
import script from "./BandView.vue?vue&type=script&lang=js"
export * from "./BandView.vue?vue&type=script&lang=js"

import "./BandView.vue?vue&type=style&index=0&id=493c9622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493c9622"]])

export default __exports__